import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { Modal } from '../custom';
import { SsoSettingsResource } from 'app/_resources/sso-settings.resource';
import { StoragePremiumServiceSubscriptionResource } from 'app/_resources/storage-premium-service-subscription.resource';
import { AuthService } from 'app/_services/auth.service';
import { ConfirmModal } from 'app/_services/confirm-modal.factory';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { TemplateModal } from 'app/_services/template-modal.factory';

class StorageAdminAllocationAlgorithmActivationComponentCtrl
    implements ng.IController
{
    private readonly disableModal: Modal = {
        template:
            'app/storage-admin/storage-admin-allocation-algorithm-disable-modal.html'
    };

    private readonly downgradeModal: Modal = {
        template:
            'app/storage-admin/storage-admin-allocation-algorithm-downgrade-modal.html'
    };

    private readonly enableModal: Modal = {
        template:
            'app/storage-admin/storage-admin-allocation-algorithm-comfirm-modal.html'
    };

    private loading: boolean = true;
    private authUser: LoginResult;
    private togglingAllocationActivation: boolean;
    private allocationServiceEnabled: boolean;
    private isUpgrade: boolean = false;
    private loadingErrorMsg: string;
    private authenticatedUser: LoginResult;
    public storagePremiumServicePackages: StoragePremiumServiceSubscriptionPackageDto[];
    public storagePremiumServiceSubscriptionPackage: StoragePremiumServiceSubscriptionCreationDto;
    public packageIdentifier: StoragePremiumServicePackage;
    public oldPackageIdentifier: StoragePremiumServicePackage;
    public storagePremiumServiceSubscriptionAllocationMethod: AllocationMethod;

    constructor(
        private storagePremiumServiceSubscriptionResource: StoragePremiumServiceSubscriptionResource,
        private ssoSettingsResource: SsoSettingsResource,
        private templateModal: TemplateModal,
        private confirmModal: ConfirmModal,
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private growl: Growl,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private $scope: ng.IScope
    ) {}

    $onInit() {
        this.authService.userLoginPromise.promise.then(
            (loggedInUser: LoginResult) => {
                this.authUser = loggedInUser;
            }
        );
        this.loading = true;
        this.authService.userLoginPromise.promise.then(
            (loginResult: LoginResult) => {
                this.authenticatedUser = loginResult;

                this.storagePremiumServiceSubscriptionResource.getPackages(
                    (res: StoragePremiumServiceSubscriptionPackageDto[]) => {
                        this.storagePremiumServicePackages = res;
                    }
                );

                this.setCurrentStoragePremiumServiceSubscriptionPackage();
            }
        );
    }

    public deactivateAllocationAlgorithm() {
        let payload: StoragePremiumServiceSubscriptionCreationDto = {
            servicePackage: 'NO_ALGORITHM',
            allocationMethod: 'NO_ALLOCATION'
        };

        return this.ssoSettingsResource.saveAllocationServiceSubscription(
            { id: this.authUser.referenceId },
            payload,
            () => this.growl.show('Successfully saved.', 'success'),
            this.errorHandler
        ).$promise;
    }

    public toggleAllocationActivation() {
        const unToggle: () => void = () =>
            (this.togglingAllocationActivation = false);

        this.togglingAllocationActivation = true;
        const disabling: boolean = this.allocationServiceEnabled;

        let result: angular.IPromise<any>;
        result = this.openModal(disabling);

        result
            .then((servicePackage?: StoragePremiumServicePackage) => {
                let promise: angular.IPromise<any>;

                if (
                    !disabling &&
                    servicePackage != null &&
                    angular.isString(servicePackage)
                ) {
                    //the actual enabling of the new service package happens in the wizard
                    promise =
                        this.setCurrentStoragePremiumServiceSubscriptionPackage();
                } else if (disabling) {
                    promise = this.deactivateAllocationAlgorithm().then(() =>
                        this.setCurrentStoragePremiumServiceSubscriptionPackage()
                    );
                } else {
                    promise = Promise.resolve();
                }

                promise.finally(unToggle);
            })
            .catch(unToggle);
    }

    private openModal(disabling: boolean) {
        if (disabling) {
            return this.templateModal(this.disableModal.template).result;
        } else {
            return this.$uibModal.open({
                templateUrl: this.enableModal.template,
                windowClass: 'min-width-dialog'
            }).result;
        }
    }

    private setCurrentStoragePremiumServiceSubscriptionPackage(): angular.IPromise<StoragePremiumServiceSubscriptionCreationDto> {
        return this.ssoSettingsResource.queryAllocationServiceSubscription(
            { id: this.authenticatedUser.referenceId },
            (res: StoragePremiumServiceSubscriptionCreationDto) => {
                this.storagePremiumServiceSubscriptionPackage = res;
                this.storagePremiumServiceSubscriptionAllocationMethod =
                    res.allocationMethod;

                this.allocationServiceEnabled =
                    res.servicePackage != 'NO_ALGORITHM';

                if (res.servicePackage && this.allocationServiceEnabled) {
                    this.packageIdentifier = res.servicePackage;
                    this.oldPackageIdentifier = this.packageIdentifier;
                }
                this.loading = false;
            },
            (err) => this.errorHandler(err)
        ).$promise;
    }

    public chooseStorageServicePackage(
        servicePackage: StoragePremiumServiceSubscriptionPackageDto
    ) {
        this.isUpgrade = false;
        const wizardContext = {
            allocationMethod:
                this.storagePremiumServiceSubscriptionAllocationMethod,
            servicePackage: servicePackage.identifier
        } as StoragePremiumServiceSubscriptionCreationDto;

        this.$uibModal
            .open({
                templateUrl: this.enableModal.template,
                windowClass: 'min-width-dialog',
                scope: angular.extend(this.$scope, {
                    wizardContext,
                    isUpgrade: this.isUpgrade
                })
            })
            .result.then(() => {
                this.setCurrentStoragePremiumServiceSubscriptionPackage();
                this.growl.show('Successfully saved.', 'success');
            });
    }
}

angular
    .module('app')
    .component('pkpStorageAdminAllocationAlgorithmActivation', {
        controller: StorageAdminAllocationAlgorithmActivationComponentCtrl,
        template:
            require('app/storage-admin/storage-admin-allocation-algorithm-activation.component.html'),
        bindings: {}
    });
